import * as React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import type { UiBaseProps } from "../uiProps.utils";

export enum SpinnerColor {
  PRIMARY = "primary",
  // The surrounding text colour, e.g. inside a button or a grey message.
  INHERIT = "inherit",
}

export type SpinnerProps = Omit<UiBaseProps, "children"> & {
  size?: number;
  color?: SpinnerColor;
  thickness?: number;
};

export const Spinner: React.FC<SpinnerProps> = (props) => <CircularProgress {...props} />;
